import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

// DELETE /api/portal/forms/drafts/:submissionId — partner discards a draft.
// Invalidates the slug-keyed detail so the page-side query refetches and
// the partner is offered a fresh draft on the next visit. The CASCADE on
// form_attachments removes attachment rows server-side.
export function useDeleteDraft(slug: string) {
  const queryClient = useQueryClient();
  return useMutation<void, ApiClientError, { submissionId: string }>({
    mutationFn: async ({ submissionId }) => {
      await apiFetch<void>(`/portal/forms/drafts/${submissionId}`, {
        method: "DELETE",
      });
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: queryKeys.portal.forms.detail(slug),
      });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to discard draft");
    },
  });
}
